import { GroupFilter } from 'shared/graphql';

import { useCurrentUser } from './useCurrentUser';
import { useUserJoinedGroups, UseUserJoinedGroupsOptions } from './useUserJoinedGroups';

type Options = Omit<UseUserJoinedGroupsOptions, 'variables'> & {
  variables?: { filter?: GroupFilter };
};

/** List all the groups that belongs to the current user. */
export function useCurrentUserGroups(options?: Options) {
  const { user } = useCurrentUser();

  const { data, count, loading, refetch, fetchMore } = useUserJoinedGroups({
    ...options,

    variables: {
      filter: options?.variables?.filter ?? {},
      user: user?.id as string,
    },
  });

  return {
    data,
    count,
    loading,
    refetch,
    fetchMore,
  };
}
